import React from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Button,
  Grid,
} from 'antd';

const ModalConfirmationControls = ({
  onCancel,
  onFinish,
  loading,
  onFinishText,
  onFinishIcon,
  onCancelIcon,
}) => {
  const screens = Grid.useBreakpoint();
  return (
    <Row className="form-submit-controls">
      <Button
        type="link"
        onClick={onCancel}
        disabled={loading}
      >
        {onCancelIcon}
        {screens.md && 'Cancelar'}
      </Button>
      <Button
        type="link"
        onClick={onFinish}
        disabled={loading}
        style={{ marginLeft: 10 }}
        className="submit-delete"
        autoFocus
      >
        {screens.md && onFinishText}
        {onFinishIcon}
      </Button>
    </Row>
  );
};

ModalConfirmationControls.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onFinish: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  onFinishText: PropTypes.string.isRequired,
  onFinishIcon: PropTypes.element,
  onCancelIcon: PropTypes.element,
};

ModalConfirmationControls.defaultProps = {
  loading: false,
  onFinishIcon: null,
  onCancelIcon: null,
};

export default ModalConfirmationControls;
